
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { lambda_type, unit_type, bool_type, int32_type, class_type, record_type, list_type, option_type, float64_type, string_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__getValidation, FormState__startLoading, FormState__setValidationResponse_5219762A, ToolId__get_unwrap, AdditionalReminderDefinitionDto, CustomIntervalDefinition, ReminderInterval, RequestedValue$1, FormState_get_empty, TokenDataDto_$reflection, RequestedValue$1_$reflection, FormState_$reflection, ClientApiResponse$1_$reflection, ReminderInterval_$reflection } from "../../Shared/Shared.js";
import { DataTransfer_DetailSet_$reflection } from "../../Shared/Set.js";
import { Helper_unitToTranslationKey, Consumable_$reflection } from "../../Shared/Consumable.js";
import { MultipleReminderCreateDto, MultipleReminderCreateDto_$reflection, ToolTypes_$reflection } from "../../Shared/Tool.js";
import { tryFind, tryHead, toArray as toArray_1, length, exists, append as append_1, filter, cons, find, ofArray, map, singleton, empty, isEmpty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { utcNow } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { newGuid } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { Cmd_ofEffect, Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { iterate, toArray, empty as empty_1, singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { getSelectedSets } from "../../Requests/Set.js";
import { getSelectedConsumables } from "../../Requests/Consumable.js";
import { Cmd_getReminderNameSuggestions, Cmd_getSelectedTools } from "../../Requests/Tool.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { unwrap, map as map_1, toArray as toArray_2, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { createObj, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { unwrapConsumableId } from "../../Shared/Helper.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { FSharpMap__get_IsEmpty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { InvalidTextValue } from "../../Components/Text.js";
import { ColumnDefinition$1, CellContent } from "../Table/Types.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { TabsMenu } from "../TabsMenu.js";
import { TableControl$1, Table as Table_1 } from "../Table/Table.js";
import Recycle_Bin_1 from "../../../public/assets/icons/Recycle_Bin_1.svg";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { InformationAlert } from "../../Components/Alert.js";
import { RadioButton } from "../../Components/RadioButton.js";
import { AutoSuggestInput } from "../../Components/Input.js";
import { DatePicker } from "../../Components/DatePicker.js";
import { Select } from "../../Components/Select.js";
import { DayWeekMonthYearInput } from "../DayWeekMonthYearInput.js";
import { AdditionalReminderWidget } from "../AdditionalReminderWidget.js";
import { TextArea } from "../../Components/TextArea.js";
import { Button } from "../../Components/Button.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { ModalSheet } from "../../Components/ModalSheet.js";
import { Skeleton } from "../../Components/Skeleton.js";

export class TableElementType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "ToolWithQuantity", "Consumable", "Set"];
    }
}

export function TableElementType_$reflection() {
    return union_type("Widgets.Modals.MultiReminderModal.TableElementType", [], TableElementType, () => [[], [], [], []]);
}

export class TableElement extends Record {
    constructor(Id, ElementId, Manufacturer, Model, Name, AdditionalName, InventoryNumber, Quanity, Type, Unit, SelectedStorageId, AvailableStorageIds) {
        super();
        this.Id = Id;
        this.ElementId = ElementId;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.Name = Name;
        this.AdditionalName = AdditionalName;
        this.InventoryNumber = InventoryNumber;
        this.Quanity = Quanity;
        this.Type = Type;
        this.Unit = Unit;
        this.SelectedStorageId = SelectedStorageId;
        this.AvailableStorageIds = AvailableStorageIds;
    }
}

export function TableElement_$reflection() {
    return record_type("Widgets.Modals.MultiReminderModal.TableElement", [], TableElement, () => [["Id", string_type], ["ElementId", string_type], ["Manufacturer", string_type], ["Model", string_type], ["Name", string_type], ["AdditionalName", string_type], ["InventoryNumber", string_type], ["Quanity", option_type(float64_type)], ["Type", TableElementType_$reflection()], ["Unit", string_type], ["SelectedStorageId", option_type(string_type)], ["AvailableStorageIds", list_type(string_type)]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Save", "SetDate", "SetTitle", "SetDescription", "SetAdditionalReminderName", "SetAdditionalReminderInterval", "SetCustomIntervalValue", "SetReminderInterval", "AddElement", "RemoveElement", "InitTableElements", "ReminderResponse", "SetsFetched", "ConsumableFetched", "ToolsFetched", "ReminderNameSuggestionsFetched", "SetIsNormalReminder", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.Modals.MultiReminderModal.Msg", [], Msg, () => [[], [["Item", class_type("System.DateTime")]], [["Item", string_type]], [["Item", string_type]], [["id", string_type], ["name", string_type]], [["id", string_type], ["interval", string_type], ["value", int32_type]], [["Item1", string_type], ["value", int32_type]], [["Item", ReminderInterval_$reflection()]], [["id", string_type]], [["id", string_type]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", list_type(DataTransfer_DetailSet_$reflection())]], [["Item", list_type(Consumable_$reflection())]], [["Item", list_type(ToolTypes_$reflection())]], [["Item", list_type(string_type)]], [["Item", bool_type]], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(FormState, SuccessCallback, OnClose, Sets, Consumables, Tools, TableElements, RemovedElements, Dto, NameSuggestions, IsNormalReminder, UserData) {
        super();
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.Sets = Sets;
        this.Consumables = Consumables;
        this.Tools = Tools;
        this.TableElements = TableElements;
        this.RemovedElements = RemovedElements;
        this.Dto = Dto;
        this.NameSuggestions = NameSuggestions;
        this.IsNormalReminder = IsNormalReminder;
        this.UserData = UserData;
    }
}

function State_$reflection() {
    return record_type("Widgets.Modals.MultiReminderModal.State", [], State, () => [["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["Sets", RequestedValue$1_$reflection(list_type(DataTransfer_DetailSet_$reflection()))], ["Consumables", RequestedValue$1_$reflection(list_type(Consumable_$reflection()))], ["Tools", RequestedValue$1_$reflection(list_type(ToolTypes_$reflection()))], ["TableElements", list_type(TableElement_$reflection())], ["RemovedElements", list_type(TableElement_$reflection())], ["Dto", MultipleReminderCreateDto_$reflection()], ["NameSuggestions", list_type(string_type)], ["IsNormalReminder", bool_type], ["UserData", TokenDataDto_$reflection()]]);
}

function init(successCallback, onClose, userData, customerConfiguration, reminderProps) {
    return [new State(FormState_get_empty(), successCallback, onClose, isEmpty(reminderProps.SetIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), isEmpty(reminderProps.ConsumableIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), isEmpty(reminderProps.ToolIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), empty(), empty(), new MultipleReminderCreateDto(utcNow(), "", "", new ReminderInterval(4, []), undefined, singleton(new AdditionalReminderDefinitionDto(newGuid(), "", new CustomIntervalDefinition("day", 3))), empty(), empty(), empty(), empty()), empty(), true, userData), Cmd_batch(toList(delay(() => append(!isEmpty(reminderProps.SetIds) ? singleton_1(getSelectedSets(reminderProps.SetIds, (Item) => (new Msg(12, [Item])), (Item_1) => (new Msg(17, [Item_1])))) : empty_1(), delay(() => append(!isEmpty(reminderProps.ConsumableIds) ? singleton_1(getSelectedConsumables(reminderProps.ConsumableIds, (Item_2) => (new Msg(13, [Item_2])), (Item_3) => (new Msg(17, [Item_3])))) : empty_1(), delay(() => append(!isEmpty(reminderProps.ToolIds) ? singleton_1(Cmd_getSelectedTools(map(ToolId__get_unwrap, reminderProps.ToolIds), (Item_4) => (new Msg(14, [Item_4])), (Item_5) => (new Msg(17, [Item_5])))) : empty_1(), delay(() => singleton_1(Cmd_getReminderNameSuggestions((Item_6) => (new Msg(15, [Item_6])), (Item_7) => (new Msg(17, [Item_7])))))))))))))];
}

function update(msg, state) {
    let bind$0040_1, bind$0040_2, bind$0040_3, bind$0040_4, bind$0040_5, bind$0040_6, bind$0040_7;
    switch (msg.tag) {
        case 16:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Consumables, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.NameSuggestions, msg.fields[0], state.UserData), Cmd_none()];
        case 11: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [new State(FormState__setValidationResponse_5219762A(state.FormState, response_1.fields[0]), state.SuccessCallback, state.OnClose, state.Sets, state.Consumables, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.NameSuggestions, state.IsNormalReminder, state.UserData), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Sets, state.Consumables, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.NameSuggestions, state.IsNormalReminder, state.UserData), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
        case 4:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Consumables, state.Tools, state.TableElements, state.RemovedElements, (bind$0040_1 = state.Dto, new MultipleReminderCreateDto(bind$0040_1.Date, bind$0040_1.Title, bind$0040_1.Description, bind$0040_1.Interval, bind$0040_1.CustomInterval, map((ar) => {
                if (ar.Id === msg.fields[0]) {
                    return new AdditionalReminderDefinitionDto(ar.Id, msg.fields[1], ar.Interval);
                }
                else {
                    return ar;
                }
            }, defaultArg(state.Dto.AdditionalReminders, empty())), bind$0040_1.ConsumableIds, bind$0040_1.ToolWithQuantityIds, bind$0040_1.SetIds, bind$0040_1.ToolIds)), state.NameSuggestions, state.IsNormalReminder, state.UserData), Cmd_none()];
        case 3:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Consumables, state.Tools, state.TableElements, state.RemovedElements, (bind$0040_2 = state.Dto, new MultipleReminderCreateDto(bind$0040_2.Date, bind$0040_2.Title, msg.fields[0], bind$0040_2.Interval, bind$0040_2.CustomInterval, bind$0040_2.AdditionalReminders, bind$0040_2.ConsumableIds, bind$0040_2.ToolWithQuantityIds, bind$0040_2.SetIds, bind$0040_2.ToolIds)), state.NameSuggestions, state.IsNormalReminder, state.UserData), Cmd_none()];
        case 2:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Consumables, state.Tools, state.TableElements, state.RemovedElements, (bind$0040_3 = state.Dto, new MultipleReminderCreateDto(bind$0040_3.Date, msg.fields[0], bind$0040_3.Description, bind$0040_3.Interval, bind$0040_3.CustomInterval, bind$0040_3.AdditionalReminders, bind$0040_3.ConsumableIds, bind$0040_3.ToolWithQuantityIds, bind$0040_3.SetIds, bind$0040_3.ToolIds)), state.NameSuggestions, state.IsNormalReminder, state.UserData), Cmd_none()];
        case 1:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Consumables, state.Tools, state.TableElements, state.RemovedElements, (bind$0040_4 = state.Dto, new MultipleReminderCreateDto(msg.fields[0], bind$0040_4.Title, bind$0040_4.Description, bind$0040_4.Interval, bind$0040_4.CustomInterval, bind$0040_4.AdditionalReminders, bind$0040_4.ConsumableIds, bind$0040_4.ToolWithQuantityIds, bind$0040_4.SetIds, bind$0040_4.ToolIds)), state.NameSuggestions, state.IsNormalReminder, state.UserData), Cmd_none()];
        case 5:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Consumables, state.Tools, state.TableElements, state.RemovedElements, (bind$0040_5 = state.Dto, new MultipleReminderCreateDto(bind$0040_5.Date, bind$0040_5.Title, bind$0040_5.Description, bind$0040_5.Interval, bind$0040_5.CustomInterval, map((ar_1) => {
                if (ar_1.Id === msg.fields[0]) {
                    return new AdditionalReminderDefinitionDto(ar_1.Id, ar_1.Name, new CustomIntervalDefinition(msg.fields[1], msg.fields[2]));
                }
                else {
                    return ar_1;
                }
            }, defaultArg(state.Dto.AdditionalReminders, empty())), bind$0040_5.ConsumableIds, bind$0040_5.ToolWithQuantityIds, bind$0040_5.SetIds, bind$0040_5.ToolIds)), state.NameSuggestions, state.IsNormalReminder, state.UserData), Cmd_none()];
        case 6:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Consumables, state.Tools, state.TableElements, state.RemovedElements, (bind$0040_6 = state.Dto, new MultipleReminderCreateDto(bind$0040_6.Date, bind$0040_6.Title, bind$0040_6.Description, bind$0040_6.Interval, new CustomIntervalDefinition(msg.fields[0], msg.fields[1]), bind$0040_6.AdditionalReminders, bind$0040_6.ConsumableIds, bind$0040_6.ToolWithQuantityIds, bind$0040_6.SetIds, bind$0040_6.ToolIds)), state.NameSuggestions, state.IsNormalReminder, state.UserData), Cmd_none()];
        case 7: {
            const value_10 = msg.fields[0];
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Consumables, state.Tools, state.TableElements, state.RemovedElements, (bind$0040_7 = state.Dto, new MultipleReminderCreateDto(bind$0040_7.Date, bind$0040_7.Title, bind$0040_7.Description, value_10, !equals(value_10, new ReminderInterval(6, [])) ? undefined : (new CustomIntervalDefinition("day", 0)), bind$0040_7.AdditionalReminders, bind$0040_7.ConsumableIds, bind$0040_7.ToolWithQuantityIds, bind$0040_7.SetIds, bind$0040_7.ToolIds)), state.NameSuggestions, state.IsNormalReminder, state.UserData), Cmd_none()];
        }
        case 8: {
            const id_2 = msg.fields[0];
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Consumables, state.Tools, cons(find((tableElement) => (tableElement.Id === id_2), state.RemovedElements), state.TableElements), filter((tableElement_1) => (tableElement_1.Id !== id_2), state.RemovedElements), state.Dto, state.NameSuggestions, state.IsNormalReminder, state.UserData), Cmd_none()];
        }
        case 9: {
            const id_3 = msg.fields[0];
            const selectedElement_1 = find((tableElement_2) => (tableElement_2.Id === id_3), state.TableElements);
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Consumables, state.Tools, filter((tableElement_3) => (tableElement_3.Id !== id_3), state.TableElements), cons(selectedElement_1, state.RemovedElements), state.Dto, state.NameSuggestions, state.IsNormalReminder, state.UserData), Cmd_none()];
        }
        case 12:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, new RequestedValue$1(1, [msg.fields[0]]), state.Consumables, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.NameSuggestions, state.IsNormalReminder, state.UserData), singleton((dispatch) => {
                dispatch(new Msg(10, []));
            })];
        case 13:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, new RequestedValue$1(1, [msg.fields[0]]), state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.NameSuggestions, state.IsNormalReminder, state.UserData), singleton((dispatch_1) => {
                dispatch_1(new Msg(10, []));
            })];
        case 14:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Consumables, new RequestedValue$1(1, [msg.fields[0]]), state.TableElements, state.RemovedElements, state.Dto, state.NameSuggestions, state.IsNormalReminder, state.UserData), singleton((dispatch_2) => {
                dispatch_2(new Msg(10, []));
            })];
        case 10: {
            const matchValue = state.Consumables;
            const matchValue_1 = state.Tools;
            const matchValue_2 = state.Sets;
            let matchResult, consumables, sets, tools;
            if (matchValue.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_1.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_2.tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                consumables = matchValue.fields[0];
                sets = matchValue_2.fields[0];
                tools = matchValue_1.fields[0];
            }
            switch (matchResult) {
                case 0:
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Consumables, state.Tools, append_1(map((set$) => (new TableElement(newGuid(), set$.Id, set$.MasterData.Manufacturer, set$.MasterData.Model, set$.MasterData.Name, "", set$.MasterData.InventoryNumber, undefined, new TableElementType(3, []), "piece", undefined, empty())), sets), append_1(map((tool) => {
                        if (tool.tag === 1) {
                            const tool_2 = tool.fields[0];
                            return new TableElement(newGuid(), ToolId__get_unwrap(tool_2.Id), tool_2.Manufacturer, tool_2.Model, tool_2.DisplayName, "", tool_2.InventoryNumber, 0, new TableElementType(1, []), "piece", undefined, empty());
                        }
                        else {
                            const tool_1 = tool.fields[0];
                            return new TableElement(newGuid(), ToolId__get_unwrap(tool_1.Id), tool_1.Manufacturer, tool_1.Model, tool_1.DisplayName, "", tool_1.InventoryNumber, undefined, new TableElementType(0, []), "piece", undefined, empty());
                        }
                    }, tools), map((consumable) => (new TableElement(newGuid(), unwrapConsumableId(consumable.Id), "", "", consumable.Name, consumable.AdditionalName, consumable.InventoryNumber, 0, new TableElementType(2, []), consumable.Unit, undefined, empty())), consumables))), state.RemovedElements, state.Dto, state.NameSuggestions, state.IsNormalReminder, state.UserData), Cmd_none()];
                default:
                    return [state, Cmd_none()];
            }
        }
        case 15:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Consumables, state.Tools, state.TableElements, state.RemovedElements, state.Dto, msg.fields[0], state.IsNormalReminder, state.UserData), Cmd_none()];
        case 17:
            return [new State(FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Sets, state.Consumables, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.NameSuggestions, state.IsNormalReminder, state.UserData), Cmd_none()];
        default: {
            let updatedDto;
            const bind$0040 = state.Dto;
            const ToolIds = map((element_1) => element_1.ElementId, filter((element) => equals(element.Type, new TableElementType(0, [])), state.TableElements));
            const SetIds = map((element_3) => element_3.ElementId, filter((element_2) => equals(element_2.Type, new TableElementType(3, [])), state.TableElements));
            updatedDto = (new MultipleReminderCreateDto(bind$0040.Date, bind$0040.Title, bind$0040.Description, bind$0040.Interval, bind$0040.CustomInterval, bind$0040.AdditionalReminders, map((element_5) => element_5.ElementId, filter((element_4) => equals(element_4.Type, new TableElementType(2, [])), state.TableElements)), map((element_7) => element_7.ElementId, filter((element_6) => equals(element_6.Type, new TableElementType(1, [])), state.TableElements)), SetIds, ToolIds));
            return [new State(FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.Sets, state.Consumables, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.NameSuggestions, state.IsNormalReminder, state.UserData), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), ["/api/multi-operations/reminder", toString(0, Auto_generateBoxedEncoder_437914C6(MultipleReminderCreateDto_$reflection(), undefined, undefined, undefined)(updatedDto))], (Item) => (new Msg(11, [Item])), (Item_1) => (new Msg(17, [Item_1])))];
        }
    }
}

function Table(props) {
    let elems_1;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const i18n = patternInput[1];
    const containsConsumables = exists((tableElement) => equals(tableElement.Type, new TableElementType(2, [])), props.TableElements);
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const columnDefinition = toArray(delay(() => append(!FSharpMap__get_IsEmpty(props.FormState.Validations) ? singleton_1(new ColumnDefinition$1("hint", "", t("assign_multiple_tools_dialog.hint"), (row) => {
        let matchValue;
        const matchValue_1 = FormState__getValidation(props.FormState, t, concat((matchValue = row.Type, (matchValue.tag === 0) ? "tool" : ((matchValue.tag === 1) ? "tool-with-quantity" : ((matchValue.tag === 3) ? "set" : "consumable"))), "-", ...row.ElementId));
        if (matchValue_1 != null) {
            const value = matchValue_1;
            return new CellContent(1, [createElement(InvalidTextValue, {
                TestId: concat(row.Id, ..."-validation.reservation.reservation_exists_for_daterange"),
                Text: value,
            })]);
        }
        else {
            return new CellContent(0, [""]);
        }
    }, "none", "text")) : empty_1(), delay(() => append(singleton_1(new ColumnDefinition$1("manufacturer", "", t("assign_multiple_tools_dialog.manufacturer"), (row_1) => (new CellContent(0, [row_1.Manufacturer])), "none", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("model", "", t("assign_multiple_tools_dialog.model"), (row_2) => (new CellContent(0, [row_2.Model])), "none", "text")), delay(() => append(containsConsumables ? singleton_1(new ColumnDefinition$1("additionalName", "", t("consumable.additional_name"), (row_3) => (new CellContent(0, [row_3.AdditionalName])), "none", "text")) : empty_1(), delay(() => append(singleton_1(new ColumnDefinition$1("name", "", t("tool.displayname"), (row_4) => (new CellContent(0, [row_4.Name])), "none", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("inventoryNumber", "", t("assign_multiple_tools_dialog.inventory_number"), (row_5) => (new CellContent(0, [row_5.InventoryNumber])), "none", "text")), delay(() => singleton_1(new ColumnDefinition$1("unit", "", t("general.unit"), (row_6) => (new CellContent(0, [t(Helper_unitToTranslationKey(row_6.Unit))])), "none", "text"))))))))))))))));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_1 = toList(delay(() => {
        let elems, arg_1, arg_3;
        return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-4", "mb-4"])], (elems = [createElement(TabsMenu, {
            Tabs: ofArray([{
                IsSelected: props.IsAddedElementTabVisible,
                Label: containsConsumables ? t("assign_multiple_tools_dialog.consumables") : t("assign_multiple_tools_dialog.tools"),
                OnClick: () => {
                    props.SetIsAddedElementTabVisible(true);
                },
                TestId: "",
            }, {
                IsSelected: !props.IsAddedElementTabVisible,
                Label: containsConsumables ? ((arg_1 = {
                    numberOfRemovedTools: length(props.RemovedElements),
                }, i18n.t("assign_multiple_tools_dialog.removed_consumables_elements", arg_1))) : ((arg_3 = {
                    numberOfRemovedTools: length(props.RemovedElements),
                }, i18n.t("assign_multiple_tools_dialog.removed_elements", arg_3))),
                OnClick: () => {
                    props.SetIsAddedElementTabVisible(false);
                },
                TestId: "",
            }]),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let TableRows, Options, TableRows_1, Options_1;
            return props.IsAddedElementTabVisible ? singleton_1(createElement(Table_1, (TableRows = toArray_1(props.TableElements), (Options = {
                BorderStyle: "row",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["manufacturer", "asc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "singleRow",
                SaveTableConfiguration: false,
            }, {
                ColumnDefinitions: columnDefinition,
                Controls: singleton(new TableControl$1(t("general.remove"), Recycle_Bin_1(), (rows) => {
                    iterate((row_8) => {
                        props.Dispatch(new Msg(9, [row_8]));
                    }, toArray_2(map_1((row_7) => row_7.Id, tryHead(rows))));
                }, true, false, "tools-dialog-toolreservation-dialog-remove-button")),
                Options: Options,
                TableKey: "not-defined-table",
                TableRows: TableRows,
            })))) : singleton_1(createElement(Table_1, (TableRows_1 = toArray_1(props.RemovedElements), (Options_1 = {
                BorderStyle: "row",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["manufacturer", "asc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "singleRow",
                SaveTableConfiguration: false,
            }, {
                ColumnDefinitions: columnDefinition,
                Controls: singleton(new TableControl$1(t("general.remove"), Recycle_Bin_1(), (rows_1) => {
                    iterate((row_10) => {
                        props.Dispatch(new Msg(8, [row_10]));
                    }, toArray_2(map_1((row_9) => row_9.Id, tryHead(rows_1))));
                }, true, false, "tools-dialog-toolreservation-dialog-remove-button")),
                Options: Options_1,
                TableKey: "not-defined-table",
                TableRows: TableRows_1,
            }))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function Form(props) {
    let elems_3;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4", "mt-4", "w-96"])], (elems_3 = toList(delay(() => {
        let elems_1;
        const intervalOptions = ofArray([{
            label: t("reminder_dialog.weekly"),
            value: new ReminderInterval(0, []),
        }, {
            label: t("reminder_dialog.monthly"),
            value: new ReminderInterval(1, []),
        }, {
            label: t("reminder_dialog.quarterly"),
            value: new ReminderInterval(2, []),
        }, {
            label: t("reminder_dialog.halfyearly"),
            value: new ReminderInterval(3, []),
        }, {
            label: t("reminder_dialog.yearly"),
            value: new ReminderInterval(4, []),
        }, {
            label: t("reminder_dialog.twoyearly"),
            value: new ReminderInterval(5, []),
        }, {
            label: t("reminder_dialog.user_defined"),
            value: new ReminderInterval(6, []),
        }]);
        return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4", "w-[30rem]"])], (elems_1 = toList(delay(() => append(props.IsNormalReminder ? singleton_1(defaultOf()) : singleton_1(createElement(InformationAlert, {
            Label: "reminder_dialog.interval_reminder_info",
        })), delay(() => {
            let elems;
            return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems = [RadioButton({
                ComponentState: componentState,
                Label: t("reminder_dialog.normal_reminder"),
                OnSelect: (_arg) => {
                    props.Dispatch(new Msg(16, [true]));
                },
                Selected: props.IsNormalReminder,
            }), RadioButton({
                ComponentState: componentState,
                Label: t("reminder_dialog.interval_reminder"),
                OnSelect: (_arg_1) => {
                    props.Dispatch(new Msg(16, [false]));
                },
                Selected: !props.IsNormalReminder,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                let dependencies_1;
                return append(singleton_1((dependencies_1 = [props.Dto.Title, props.NameSuggestions, componentState], reactApi.useMemo(() => createElement(AutoSuggestInput, {
                    ComponentState: componentState,
                    Label: t("general.name"),
                    OnChange: (value_5) => {
                        props.Dispatch(new Msg(2, [value_5]));
                    },
                    Suggestions: props.NameSuggestions,
                    TestId: "",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "title")),
                    Value: props.Dto.Title,
                }), dependencies_1))), delay(() => append(singleton_1(createElement(DatePicker, {
                    ComponentState: componentState,
                    IsClearable: false,
                    Label: props.IsNormalReminder ? t("general.date") : t("reminder_dialog.first_execution"),
                    OnChange: (date) => {
                        if (date == null) {
                        }
                        else {
                            props.Dispatch(new Msg(1, [date]));
                        }
                    },
                    TestId: "",
                    Value: props.Dto.Date,
                })), delay(() => {
                    let matchValue, interval;
                    return append(props.IsNormalReminder ? singleton_1(defaultOf()) : singleton_1(createElement(Select, {
                        ComponentState: componentState,
                        IsClearable: false,
                        Label: t("reminder_dialog.interval"),
                        NoOptionsMessage: "",
                        OnChange: (option) => {
                            if (option == null) {
                            }
                            else {
                                props.Dispatch(new Msg(7, [option.value]));
                            }
                        },
                        Options: intervalOptions,
                        PlaceholderKey: "",
                        TestId: "reminder-interval-select",
                        Value: unwrap((matchValue = props.Dto.Interval, (matchValue == null) ? {
                            label: t("reminder_dialog.yearly"),
                            value: new ReminderInterval(4, []),
                        } : ((interval = matchValue, tryFind((option_2) => equals(option_2.value, interval), intervalOptions))))),
                    })), delay(() => {
                        let matchValue_1, matchValue_2, Value_3;
                        return append((matchValue_1 = props.Dto.Interval, (matchValue_1 == null) ? (empty_1()) : ((matchValue_2 = matchValue_1, (matchValue_2.tag === 1) ? (empty_1()) : ((matchValue_2.tag === 2) ? (empty_1()) : ((matchValue_2.tag === 3) ? (empty_1()) : ((matchValue_2.tag === 4) ? (empty_1()) : ((matchValue_2.tag === 5) ? (empty_1()) : ((matchValue_2.tag === 6) ? singleton_1(createElement(DayWeekMonthYearInput, (Value_3 = (defaultArg(map_1((ci) => (ci.Value | 0), props.Dto.CustomInterval), 0) | 0), {
                            ComponentState: componentState,
                            InitialInterval: unwrap(map_1((ci_1) => ci_1.Interval, props.Dto.CustomInterval)),
                            IsBefore: false,
                            SetValue: (value_7) => {
                                let tupledArg;
                                props.Dispatch((tupledArg = value_7, new Msg(6, [tupledArg[0], tupledArg[1]])));
                            },
                            Value: Value_3,
                        }))) : (empty_1()))))))))), delay(() => append(singleton_1(createElement(AdditionalReminderWidget, {
                            AdditionlReminders: defaultArg(props.Dto.AdditionalReminders, empty()),
                            ComponentState: componentState,
                            SetInterval: (tupledArg_2) => {
                                props.Dispatch(new Msg(5, [tupledArg_2[0], tupledArg_2[1], tupledArg_2[2]]));
                            },
                            SetName: (tupledArg_1) => {
                                props.Dispatch(new Msg(4, [tupledArg_1[0], tupledArg_1[1]]));
                            },
                        })), delay(() => singleton_1(createElement(TextArea, {
                            ComponentState: componentState,
                            Label: t("general.description"),
                            OnChange: (value_12) => {
                                props.Dispatch(new Msg(3, [value_12]));
                            },
                            TestId: "reminder-description",
                            Value: props.Dto.Description,
                        }))))));
                    }));
                }))));
            }));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let elems_2, Label_6;
            return singleton_1(reactElement("div", createObj(singleton((elems_2 = [createElement(Button, (Label_6 = t("general.save"), {
                ComponentState: (componentState === "disabled") ? "disabled" : (props.IsTableElementsEmpty ? "disabled" : "enabled"),
                Label: Label_6,
                OnClick: () => {
                    props.Dispatch(new Msg(0, []));
                },
                TestId: "multiple-reminder-save-button",
                Variant: "primary",
            }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function Content(props) {
    let elems_2, elems_1;
    const patternInput = useTranslation();
    const patternInput_1 = reactApi.useState(true);
    const isAddedElementsTabSelected = patternInput_1[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["min-h-48"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["p-4"])], (elems_1 = toList(delay(() => {
        let elems;
        return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(Table, {
            Dispatch: props.Dispatch,
            FormState: props.FormState,
            IsAddedElementTabVisible: isAddedElementsTabSelected,
            RemovedElements: props.RemovedElements,
            SetIsAddedElementTabVisible: patternInput_1[1],
            TableElements: props.TableElements,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let IsTableElementsEmpty;
            return isAddedElementsTabSelected ? singleton_1(createElement(Form, (IsTableElementsEmpty = isEmpty(props.TableElements), {
                Dispatch: props.Dispatch,
                Dto: props.Dto,
                FormState: props.FormState,
                HasTableElementEmptyStorageId: exists((tableElement) => (tableElement.SelectedStorageId == null), props.TableElements),
                IsNormalReminder: props.IsNormalReminder,
                IsTableElementsEmpty: IsTableElementsEmpty,
                NameSuggestions: props.NameSuggestions,
            }))) : empty_1();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function MultiReminderModalSheet(props) {
    let elems, matchValue, matchValue_1, matchValue_2;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.SuccessCallback, props.OnClose, props.UserData, props.CustomerConfiguration, props.ReminderProps), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput[0];
    const patternInput_1 = useTranslation();
    return reactElement("div", createObj(singleton((elems = [createElement(ModalSheet, {
        CloseButtonTestId: "",
        Content: (matchValue = state_1.Consumables, (matchValue_1 = state_1.Sets, (matchValue_2 = state_1.Tools, (matchValue.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_1.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_2.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : createElement(Content, {
            Dispatch: patternInput[1],
            Dto: state_1.Dto,
            FormState: state_1.FormState,
            IsNormalReminder: state_1.IsNormalReminder,
            NameSuggestions: state_1.NameSuggestions,
            RemovedElements: state_1.RemovedElements,
            TableElements: state_1.TableElements,
        })))))),
        Controls: empty(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: patternInput_1[0]("dialog.reminder.btn_title"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

